import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';

interface TellGatewayAccountListProps {
    account: any;
}

const TellGatewayAccountList = ({ account }: TellGatewayAccountListProps) => {
    const translate = useTranslate('consent');

    return (
        <div className="tell-gateway-accounts">
            <div className="account-item">
                <div className="account-item-info">
                    <Typography tag="h1">
                        {account.accountName} - {account.accountNumber}
                    </Typography>
                    <Typography tag="p">
                        {translate('currentAccount')}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default TellGatewayAccountList;
